import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 8px;

  border: 1px solid #151a5d;
  background-color: #0f113e;
`;
